import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from 'views/login';
import { getToken } from 'utils/storage';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ 'views/home'),
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import(/* webpackChunkName: "wallet" */ 'views/wallet'),
  },
  {
    path: '/trade/:tuple',
    name: 'Trade',
    component: () => import(/* webpackChunkName: "trade" */ 'views/trade'),
  },
  {
    path: '/futures-usd/:cycle',
    name: 'Futures-usd',
    component: () => import(/* webpackChunkName: "futures-usd" */ 'views/futuresUsd'),
  },
  {
    path: '/futures-usdt/:cycle',
    name: 'Futures-usdt',
    component: () => import(/* webpackChunkName: "futures-usdt" */ 'views/futuresUsdt'),
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/user',
    name: 'User',
    component: () => import(/* webpackChunkName: "user" */ 'views/user'),
  },
  // {
  //   path: '/user',
  //   name: 'user',
  //   component: () => import(/* webpackChunkName: "user" */ 'views/user'),
  //   children: [
  //     {
  //       path: 'detail',
  //       component: () => import(/* webpackChunkName: "detail" */ 'views/detail'),
  //     },
  //   ],
  // },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "notFound" */ 'views/notFound'),
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (!getToken() && to.path !== '/login') {
    next({ path: '/login' });
  } else {
    next();
  }
});

export default router;
